<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">

            <v-layout row wrap>
                <v-flex xs12 md4>
                    <v-layout row wrap>
                        <v-flex xs12 v-for="facility in facilityPower" v-if="facility.totalCurrent">
                            <v-card flat class="mr-4 mb-4">
                                <v-card-title class="primary white--text headline">
                                       <span class="cursor-as-pointer" @click="openFacilityEnergy(facility)">
                                           {{facility.name}} : {{facility.totalCurrent.toFixed(2)}} kWh
                                       </span>
                                    <v-spacer></v-spacer>
                                    <span v-bind:class="{ 'green-thing green-icon': facility.powerDiff<=0 }">{{facility.powerDiff.toFixed(2)}} %
                                            <v-icon v-show="facility.powerDiff<=0">fa-long-arrow-alt-down</v-icon>
                                            <v-icon v-show="facility.powerDiff>0">fa-long-arrow-alt-up</v-icon>
                                        </span>
                                </v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <vue-plotly disable-responsive :data="facility.plotData" :layout="facility.plotLayout" :options="{}"/>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md8>
                    <v-card flat>
                        <v-card-title class="primary white--text headline">
                            Facility Overview : {{totalCP.toFixed(2)}} kWh
                            <v-spacer></v-spacer>
                            <span v-bind:class="{ 'green-thing green-icon': powerDiff<=0 }">{{powerDiff.toFixed(2)}} %
                                            <v-icon v-show="powerDiff<=0">fa-long-arrow-alt-down</v-icon>
                                            <v-icon v-show="powerDiff>0">fa-long-arrow-alt-up</v-icon>
                                        </span>
                        </v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <vue-plotly disable-responsive :data="energyData" :layout="energyLayout" :options="{}"/>
                            </v-flex>
                            <v-flex xs12>
                                <vue-plotly disable-responsive :data="energyPerFacilityData"
                                            @click="openFacilityEnergyFromPlot"
                                            :layout="energyPerFacilityLayout" :options="{}"/>
                            </v-flex>
                            <v-flex xs12>
                                <vue-plotly disable-responsive v-if="faultsPerFacilityData" :data="faultsPerFacilityData"
                                            @click="openFacilityFaults"
                                            :layout="faultsPerFacilityLayout" :options="{}"/>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>

</template>

<script>
    import VuePlotly from '@/components/VuePlotly'
    import {callAPI} from '@/helper'
    import moment from 'moment'

    export default {
        name: 'FacilityOverview',
        components: {VuePlotly},
        computed:{

        },
        data () {
            return {
                severityColors:{
                    critical:'rgb(148, 103, 189)',
                    low:'rgb(188, 189, 34)',
                    medium:'rgb(255, 127, 14)',
                    high:'rgb(214, 39, 40)',
                },
                baseDate:  moment().subtract(8, "days"),
                endDate:  moment().subtract(1, "days"),
                plantCOP:null,
                totalCP:null,
                powerDiff:null,
                notifTraces:null,
                dateRange:  {start:moment().subtract(8, "days").format("YYYY-MM-DD"),end:moment().subtract(1, "days").format("YYYY-MM-DD")},
                loading:true,
                facilityPower:[],
                facilityList:{
                    "Exchange Square":{
                        endpoint:"https://es-demo-dot-pdm-229904.appspot.com",
                        facilityName:"ES",
                        feBase:"https://hkl-es.jec-digital.com"
                    },
                    "Chater House":{
                        endpoint:"https://ch-demo-dot-pdm-229904.appspot.com",
                        facilityName:"CH",
                        feBase:"https://hkl-ch.jec-digital.com"
                    },
                    "Prince's Building":{
                        endpoint:"https://pb-demo-dot-pdm-229904.appspot.com",
                        facilityName:"PB",
                        feBase:"https://hkl-pb.jec-digital.com"
                    },
                    "Jardine House":{
                        endpoint:"https://jh-demo-dot-pdm-229904.appspot.com",
                        facilityName:"JH",
                        feBase:"https://hkl-jh.jec-digital.com"
                    },
                    "Alexandra House":{
                        endpoint:"https://ax-demo-dot-pdm-229904.appspot.com",
                        facilityName:"AX",
                        feBase:"https://hkl-ax.jec-digital.com"
                    },
                    "Landmark":{
                        endpoint:"https://lm-demo-dot-pdm-229904.appspot.com",
                        facilityName:"LM",
                        feBase:"https://hkl-lm.jec-digital.com"
                    }
                },
                energyData:null,
                energyLayout:{
                    title:"Total Energy Consumption VS Baseline",
                    legend: {
                        orientation: 'h',
                        y:-0.3
                    },
                    yaxis: {
                        title: 'Energy (kWh)'
                    },
                    xaxis: {
                        title: 'Time (daily)'
                    }
                },
                energyPerFacilityData:null,
                energyPerFacilityLayout:{
                    title:"Energy Consumption (kWh)",
                    grid: {rows: 2, columns: 3, pattern: 'independent'},
                    bargap: 0.2,
                    bargroupgap: 0.2,
                    showlegend:false,
                },
                faultsPerFacilityData:null,
                faultsPerFacilityLayout:{
                    title:"Faults Summary",
                    legend: {
                        orientation: 'h',
                        y:-0.3
                    },
                    barmode: 'group'
                },


            }
        },
        methods:{
            addArrays(ar1, ar2){
                let ar3 = [];
                for(let i in ar1)
                    ar3.push(ar1[i] + ar2[i]);
                return ar3;
            },
            openFacilityEnergy(facility){
                let pass = localStorage.getItem('pass');
                window.open(facility.feBase+"/hkl-energy?token="+pass+"&rangeStart="+
                    this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss')+"&rangeEnd="+
                    this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'), '_blank');
            },
            openFacilityFaults(data){
                let pass = localStorage.getItem('pass');
                window.open(this.facilityList[data.points[0].x].feBase+"/notification-breakdown?token="+pass+"&rangeStart="+
                    this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss')+"&rangeEnd="+
                    this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'), '_blank');
            },
            openFacilityEnergyFromPlot(data){
                let pass = localStorage.getItem('pass');
                window.open(this.facilityList[data.points[0].x].feBase+"/hkl-energy?token="+pass+"&rangeStart="+
                    this.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss')+"&rangeEnd="+
                    this.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss'), '_blank');
            },
            getData(){
                let me=this;
                me.loading=true
                let currentRange=[me.baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),me.endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let pastRange=[moment(currentRange[0]).subtract(7, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss'),moment(currentRange[1]).subtract(7, "days").endOf('day').format('YYYY-MM-DD HH:mm:ss')]
                let currentPowerPromisses=[]
                let pastPowerPromisses=[]
                let notifPromises=[]
                for (let facility in me.facilityList){
                    let apiBaseUrl=me.facilityList[facility].endpoint
                    currentPowerPromisses.push(callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.facilityList[facility].facilityName,
                                'sensor_names': ["Power"],
                                'date_range':currentRange,
                            },
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "H", "agg_op": "sum"}
                            ],
                            "apiBaseUrl":apiBaseUrl,
                            "mfTagFacility":facility
                        }
                    ))
                    pastPowerPromisses.push(callAPI('data2/',
                        {
                            'filters': {
                                'facility_name': me.facilityList[facility].facilityName,
                                'sensor_names': ["Power"],
                                'date_range':pastRange,
                            },
                            "pipeline": [
                                {"type": "agg_h", "agg_op": "sum"},
                                {"type": "agg", "agg": "H", "agg_op": "sum"}
                            ],
                            "apiBaseUrl":apiBaseUrl,
                            "mfTagFacility":facility
                        }
                    ))
                    notifPromises.push(callAPI('notification/',{
                        facility_name: me.facilityList[facility].facilityName,
                        apiBaseUrl:apiBaseUrl,
                        date_range:currentRange,
                        mfTagFacility:facility
                    }))
                }
                Promise.all(notifPromises).then(function (notifReses) {
                    let severityColors={
                        critical:'rgb(148, 103, 189)',
                        low:'rgb(188, 189, 34)',
                        medium:'rgb(255, 127, 14)',
                        high:'rgb(214, 39, 40)',
                    }
                    let traces=["low","medium","high","critical"].map(val=>{return{
                        'x':[],
                        'y':[],
                        'name': val,
                        'type': 'bar',
                        'marker': {
                            'color': severityColors[val]
                        }
                    }})
                    for (let notifRes of notifReses) {
                        let rangeFaults = notifRes.data.result
                        let facility = JSON.parse(notifRes.config.data)["mfTagFacility"]
                        for (let trace of traces){
                            trace.x.push(facility)
                            trace.y.push(rangeFaults.filter(x=>x.severity==trace.name).length)
                        }
                    }
                    me.faultsPerFacilityData=traces
                })
                Promise.all(currentPowerPromisses).then(function (reses) {
                    let power={}
                    let timestamp=null
                    let currentPower=null
                    let pastPower=null
                    for (let res of reses) {
                        let facility = JSON.parse(res.config.data)["mfTagFacility"]
                        if (!timestamp && res.data.timestamp) {
                            timestamp = res.data.timestamp;
                        }
                        if(res.data['sum']) {
                            let powerForThis = res.data['sum'].map(x => x / me.$store.state.pointsListStore.pointsList.sampling_freq)
                            if (!currentPower) {
                                currentPower = powerForThis
                            } else {
                                currentPower = me.addArrays(currentPower, powerForThis)
                            }
                            if (!power[facility]) {
                                power[facility] = {
                                    name: facility,
                                    feBase: me.facilityList[facility].feBase
                                }
                            }
                            power[facility].current = powerForThis
                            power[facility].totalCurrent = powerForThis.reduce((sum, x) => sum + x, 0)
                        }
                    }
                    me.totalCP=currentPower.reduce((sum, x) => sum + x,0)
                    Promise.all(pastPowerPromisses).then(function (reses) {
                        for (let res of reses) {
                            let facility = JSON.parse(res.config.data)["mfTagFacility"]
                            if(res.data['sum']) {
                                let powerForThis = res.data['sum'].map(x => x / me.$store.state.pointsListStore.pointsList.sampling_freq)
                                if (!pastPower) {
                                    pastPower = powerForThis
                                } else {
                                    pastPower = me.addArrays(pastPower, powerForThis)
                                }
                                if (!power[facility]) {
                                    power[facility] = {
                                        name: facility
                                    }
                                }
                                power[facility].past = powerForThis
                                power[facility].totalPast = powerForThis.reduce((sum, x) => sum + x, 0)
                            }
                        }
                        let pastPowerTotal=pastPower.reduce((sum, x) => sum + x,0)
                        me.powerDiff=-((pastPowerTotal-me.totalCP)/pastPowerTotal)*100
                        let facilityNames=[]
                        let facilityCP=[]
                        let facilityPP=[]
                        for (let index in power){
                            let item=power[index]
                            facilityNames.push(item.name)
                            facilityCP.push(item.totalCurrent)
                            facilityPP.push(item.totalPast)
                            item.plotData=[
                                {x:timestamp,y:item.current,name:"Energy",fill: 'tozeroy',fillcolor:"rgba(31, 119, 180,0.5)",mode:"lines",line:{color:"rgba(31, 119, 180,0.5)"}},
                                {x:timestamp,y:item.past,
                                    name:"Baseline ("+moment(pastRange[0]).format('YYYY-MM-DD')+" - "+moment(pastRange[1]).format('YYYY-MM-DD')+")",
                                    mode:"lines",
                                    line:{color:"rgb(255, 127, 14)"}
                                },
                            ]
                            item.plotLayout={
                                title:item.name+" Energy Consumption VS Baseline",
                                legend: {
                                    orientation: 'h',
                                    y:-0.3
                                },
                                height:300,
                                yaxis: {
                                    title: 'Energy (kWh)'
                                },
                                xaxis: {
                                    title: 'Time (daily)'
                                },
                                margin:{
                                    l: 50,
                                    r: 20,
                                    t:60,
                                    pad: 1
                                },
                            }
                            item.powerDiff=-((item.totalPast-item.totalCurrent)/item.totalPast)*100
                        }
                        me.facilityPower=Object.values(power);
                        me.energyData=[
                            {x:timestamp,y:currentPower,name:"Energy",fill: 'tozeroy',fillcolor:"rgba(31, 119, 180,0.5)",mode:"lines",line:{color:"rgba(31, 119, 180,0.5)"}},
                            {x:timestamp,y:pastPower,
                                name:"Baseline ("+moment(pastRange[0]).format('YYYY-MM-DD')+" - "+moment(pastRange[1]).format('YYYY-MM-DD')+")",
                                mode:"lines",
                                line:{color:"rgb(255, 127, 14)"}
                            },
                        ]
                        let epfdata=[];
                        for (let nameIndex in facilityNames){
                            let comp1={
                                x:[facilityNames[nameIndex]],
                                y:[facilityCP[nameIndex]],
                                width:[0.2],
                                name:"Energy",
                                marker: {
                                    color: 'rgb(31, 119, 180)',
                                    width:0.2
                                },
                                type: 'bar',
                            }
                            let comp2={
                                x:[facilityNames[nameIndex]],
                                y:[facilityPP[nameIndex]],
                                width:[0.2],
                                name:"Baseline",
                                marker: {
                                    color: 'rgb(255, 127, 14)',
                                    width:0.2
                                },
                                type: 'bar',
                            }
                            if(nameIndex>0){
                                let jscantcount=parseInt(nameIndex)+1
                                comp1.xaxis='x'+String(jscantcount)
                                comp2.xaxis='x'+String(jscantcount)
                                comp1.yaxis='y'+String(jscantcount)
                                comp2.yaxis='y'+String(jscantcount)
                            }
                            epfdata.push(comp1)
                            epfdata.push(comp2)

                        }
                        me.energyPerFacilityData=epfdata
                        me.loading=false;
                    })
                })





            }
        },
        beforeMount() {
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.baseDate=moment(maxDate).subtract(8, "days")
                this.endDate=moment(maxDate).subtract(1, "days")
                this.dateRange={start:this.baseDate.format('YYYY-MM-DD'),end:this.endDate.format('YYYY-MM-DD')}
            }
            this.getData();
        }


    }
</script>

<style>
    .green-icon .theme--light.v-icon{
        color: #77C16B;
    }
    .green-icon .theme--dark.v-icon{
        color: #77C16B;
    }
    .green-thing{
        color: #77C16B;
    }
</style>
